import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import styled from 'styled-components';

import { UnitType } from '~/src/types/Misc';
import PrimaryButton from '../../../../../../components/common/forms/Button/PrimaryButton';
import SecondaryButton from '../../../../../../components/common/forms/Button/SecondaryButton';
import TextInputComponent from '../../../../../../components/common/forms/TextInput/TextInputComponent';
import BorderlessButton from '~/src/components/common/forms/Button/BorderlessButton';
import BaseButton from '~/src/components/common/forms/Button/BaseButton';

import xIcon from '../../../../../../static/img/xIcon.svg';

const amountSchema = (max: number): yup.AnyObjectSchema => {
  return yup.object().shape({
    amount: yup
      .number()
      .typeError('Must be a number')
      .test('Is positive?', 'Must be >= 0', (value) => value >= 0)
      // .max(max, `Must be smaller than ${max}`)
      .integer('Must be an integer')
      .required('Is required'),
  });
};
interface Props {
  tempId: string;
  maxNumber: number;
  unitType: UnitType;
  reserve: (quantityId: string, type: UnitType, amount: number) => void;
  clear: (tempId: string, type: UnitType) => void;
}
export default function ButtonQuantities({ tempId, maxNumber, unitType, reserve, clear }: Props): JSX.Element {
  const formik = useFormik({
    initialValues: {
      amount: '',
    },
    validationSchema: amountSchema(maxNumber),
    onSubmit: async () => { },
  });

  return (
    <div style={{ height: '100%', width: '244px !important' }}>
      <form
        className="form-inline"
        style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <InputWrapper>
          <TextInputComponent
            name="amount"
            value={formik.values.amount}
            touched={formik.touched}
            errors={formik.errors}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            height={25}
            cols={12}
            inlineStyles={{ width: '130px' }}
            style={{ width: '119px' }}
          // disabled={maxNumber === 0}
          />

          <StyledButton>
            <BaseButton
              title="Get"
              onClick={(): void => {
                formik.validateForm();
                if (formik.isValid) {
                  const number = parseInt(formik.values.amount, 10);
                  if (!isNaN(number)) {
                    reserve(tempId, unitType, number);
                  }
                }
              }}
            />
          </StyledButton>
        </InputWrapper>
        <SecondaryButton
          title="Max"
          onClick={(): void => {
            reserve(tempId, unitType, maxNumber);
          }}
        />
        <BorderlessButton
          icon={xIcon}
          onClick={(): void => {
            clear(tempId, unitType);
          }}
          iconSize={25}
        />
      </form>
    </div>
  );
}
const InputWrapper = styled.div`
  position: relative;
  display: flex;
  height: 25px;
  .form-control {
    margin: 0;
  }
`;

const StyledButton = styled.div`
  position: absolute;
  right: 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  height: 25px;
  border-left: 1px solid #eee;
  button {
    padding: 3px;
    color: #ef7d00;
    font-size: 14px;
    line-height: 17px;
    background: transparent;
  }
`;
